/**
 * Audit log helper — writes non-blocking activity entries to Firestore.
 * Call this from any page after a successful create / edit / delete.
 *
 * Usage:
 *   import { logActivity } from '../utils/auditLog';
 *   await logActivity(db, user, 'crear', 'Pago', 'Comida — $3,500');
 *
 * Actions: 'crear' | 'editar' | 'eliminar'
 */
import { addDoc, collection, serverTimestamp } from 'firebase/firestore';

export async function logActivity(db, user, action, entity, details = '') {
  try {
    await addDoc(collection(db, 'auditLog'), {
      timestamp:  serverTimestamp(),
      userId:     user?.uid     || '',
      userName:   user?.displayName || user?.email?.split('@')[0] || 'Usuario',
      userEmail:  user?.email   || '',
      action,   // 'crear' | 'editar' | 'eliminar'
      entity,   // e.g. 'Pago', 'Gasto', 'Vacaciones', 'Fondo', 'Pasivo'
      details,  // human-readable description of what changed
    });
  } catch (err) {
    // Audit log is non-critical — never let it break the main operation
    console.warn('Audit log write failed:', err.message);
  }
}
